import api from "./axios";
import log from "../utils/log";

export const CheckUserApproval = async userId => {
  try {
    const response = await api.get(`/api/v1/customer/users/approval/${userId}`);
    return response.data;
  } catch (error) {
    log.error(
      error.response?.data?.message ||
      "Failed to update email. Please try again."
    );
    return null;
  }
};

export const checkApproval = async () => {
  try {
    const response = await api.get(`/api/v1/user/check-approval`);
    return response.data;
  } catch (error) {
    log.error(
      error.response?.data?.message ||
      "Failed to update email. Please try again."
    );
    return null;
  }
};

export const fetchDataById = async id => {
  try {
    const response = await api.get(`/api/v1/customer/user/profile/${id}`);
    return response.data;
  } catch (error) {
    log.error("Error fetching rejection reason:", error);
    return null;
  }
};

export const updateUserLocation = async bodyContent => {
  try {
    const response = await api.put(
      `/api/v1/customer/user/preferences/save/location`,
      bodyContent
    );
    return response.data;
  } catch (error) {
    log.error("Error fetching rejection reason:", error);
    return null;
  }
};

export const getResponse = async editPoint => {
  try {
    const response = await api.get(`/api/v1/${editPoint}`);
    return response.data;
  } catch (error) {
    log.error("Error fetching rejection reason:", error);
    return null;
  }
};

export const deleteLatestRejectReason = async () => {
  try {
    const response = await api.put(
      `/api/v1/customer/users/deleteLatestRejectReason`
    );
    return response.data;
  } catch (error) {
    log.error("Error fetching rejection reason:", error);
    return null;
  }
};

export const getBasicDetails = async id => {
  try {
    const response = await api.get(`/api/v2/user/getUserBasicDetail/${id}`);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong");
  }
};

export const getUserMedia = async () => {
  try {
    const response = await api.get("/api/v1/customer/update/media");
    return response.data;
  } catch (error) {
    log.error(error.response?.data);
  }
};

export const updateUserMedia = async payload => {
  try {
    const response = await api.post(
      "/api/v1/customer/users/mediaupdate",
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    log.error(error.response?.data);
  }
};

export const updateApproveUserMedia = async payload => {
  try {
    const response = await api.post(
      "/api/v1/customer/update/mediaupdate",
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    log.error(error.response?.data);
  }
};

export const getUserUpdateMedia = async () => {
  try {
    const response = await api.get("/api/v1/customer/update/updated-media");
    return response.data;
  } catch (error) {
    log.error(error.response?.data);
  }
};

export const deleteUserUpdateMedia = async () => {
  try {
    const response = await api.delete("/api/v1/customer/update/delete-media");
    return response.data;
  } catch (error) {
    log.error(error.response?.data);
  }
};
export const getUserActionStatus = async id => {
  try {
    return (await api.get(`/api/v2/user/chat/action-status/${id}`))?.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong");
  }
};
export const updateQuestionAnswer = async data => {
  try {
    const response = await api.post(`/api/v2/user/update/QuestionAnswer`, data);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong");
  }
};
export const updateQuestionAnswerRequest = async data => {
  try {
    const response = await api.post(`/api/v2/user/update/QuestionAnswerRequest`, data);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong");
  }
};
export const questionAnswersList = async () => {
  try {
    const response = await api.get(`/api/v1/customer/update/questionss`);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong");
  }
};
export const getQuestionsCount = async () => {
  try {
    const response = await api.get(`/api/v1/customer/users/answers/count`);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong");
  }
};
export const getUpdateQuestionsCount = async () => {
  try {
    const response = await api.get(
      `/api/v1/customer/update/updateanswers/count`
    );
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong");
  }
};


